@if (!quantityControlValue) {
<button
  class="btn btn-primary btn-size-runs-apply"
  (click)="applyQuantity()"
  i18n="Config Strip|Size-runs apply button text@@sizeRunsApplyBtn"
>
  Apply
  <fa-icon class="ml-2" [icon]="['far', 'arrow-right']" size="sm"></fa-icon>
</button>
} @else {
<atx-clikable-amount-input
  [formControl]="quantityControl"
  [max]="maxQuantity"
  (click)="$event.stopPropagation()"
></atx-clikable-amount-input>
}
